import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { AngularModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-set-job-match-status',
  templateUrl: './set-job-match-status.component.html',
  styleUrls: ['./set-job-match-status.component.css']
})
export class SetJobMatchStatusComponent implements OnInit {

  @ViewChild('setStatusForm', { static: false }) setStatusForm: NgForm;
  @Input() jobMatchDetailsArrayString: any;
  @Input() statusType: any;
  @Input() multipleFlag: any;
  @Input() sourceScreen: any;
  @Input() formalizeActivityPayload: any;

  @Output() saveCallback = new EventEmitter<any>();

  jobMatchesDataArray: any = [];
  jobMatchDetailsArray: any = [];
  jobMatchesWhoseStatusCanBeSetArray: any = [];
  jobMatchesWhoseStatusCannotBeSetArray: any = [];
  statusDisplayLabel: any = '';
  notes: any = '';
  pendingItemsData: any = [];
  externalNotesAction: any = {};
  releaseReasonCodes: any = [];
  selectedClients: any = [];
  userId: any;
  companyId: any;
  companyName: any;
  jobMatches: any = [];
  clients: any = [];
  externalNote: any = '';
  copyNote: any = '';

  isLoading: boolean = true;
  savingFlag: boolean = false;
  isSharedRequisition: boolean = false;
  loadingJobMatchesAndPendingItemsDataFlag: boolean = true;
  doNotHire: boolean = false;
  doNotHireAtClient: boolean = false;
  isStaffingCompany: boolean = false;

  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private jobMatchService: JobMatchService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private candidateService: CandidateService,
    private modalService: AngularModalService
  ) { }

  ngOnInit() {
    this.userId = this.authService.getUserDetails().id;
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.companyName = this.authService.getUserDetails().company.companyName;
    this.jobMatchDetailsArray = this.jobMatchDetailsArrayString;

    this.isStaffingCompany = this.companyService.isStaffingCompany();

    switch (this.statusType) {
      case 'Not Interested':
        this.statusDisplayLabel = 'Not Interested';
        break;
      case 'Release':
        this.statusDisplayLabel = 'Released';
        break;
    }

    this.setJobMatchDetailsArray();

    if ((this.statusType == 'Release' || this.statusType == 'Not Interested')) {
      this._getReasonCodes(() => {
        this._getCandidatesInfo();
        if (!this.multipleFlag && this.statusType == 'Release') {
          this._getOtherJobMatchesOfCandidate(() => { });
          if (this.isStaffingCompany) {
            this._getClients(() => { });
          }
        }
      });
    } else {
      this._getCandidatesInfo();
    }
  }

  setJobMatchDetailsArray() {
    if (this.jobMatchDetailsArray && this.jobMatchDetailsArray.length > 0) {
      this.jobMatchDetailsArray.forEach((val, key) => {
        let tempObject: any = {};
        tempObject.loadingFlag = true;
        tempObject.loadingPendingItemsFlag = true;
        tempObject.jobMatchId = val.jobMatchId;
        tempObject.candidateId = val.candidateId;
        tempObject.workflowStepName = val.workflowStepName;
        tempObject.jobMatchData = {};
        tempObject.pendingItemsData = {};
        tempObject.pendingItemsExistFlag = false;
        tempObject.meetingType = '';
        tempObject.meetingsPopOverTitle = '';
        tempObject.meetingUserLabel = '';
        tempObject.meetingInfoArray = [];
        tempObject.message = '';
        tempObject.showAlert = false;
        this.jobMatchesDataArray.push(tempObject);
      });
    }
  }

  _getReasonCodes(successCallback) {
    let workflowSteps = [];
    this.jobMatchesDataArray.forEach((candidateInfo, index) => {
      let stepName = "";
      switch (candidateInfo.workflowStepName) {
        case 'Recruiter Screening':
          stepName = 'RECRUITER_SCREENING';
          break;
        case 'Tech Assessment':
          stepName = 'TECH_ASSESSMENT';
          break;
        case 'Value Assessment':
          stepName = 'VALUE_ASSESSMENT';
          break;
        case 'Phone Screen':
          stepName = 'PHONE_SCREEN';
          break;
        case 'Interview':
          stepName = 'INTERVIEW';
          break;
        case 'Not Interested':
          stepName = 'NOT_INTERESTED';
          break;
        case 'Released':
          stepName = 'RELEASED';
          break;
      }
      if ((this.statusType == 'Not Interested' && candidateInfo.workflowStepName == 'Not Interested') || (this.statusType == 'Release' && candidateInfo.workflowStepName == 'Released')) {
        candidateInfo.isCandidateStatusAlreadyChanged = true;
      } else if (this.statusType == 'Not Interested') {
        stepName = 'NOT_INTERESTED';
        candidateInfo.workflowStepName = 'Not Interested';
      } else if (stepName == 'NOT_INTERESTED' && this.statusType == 'Release') {
        stepName = 'RELEASED';
        candidateInfo.workflowStepName = 'Released';
      }
      if (!workflowSteps.includes(stepName)) {
        workflowSteps.push(stepName);
      }
    });

    this.jobMatchService.getReasonCodes(workflowSteps, (data) => {
      this.releaseReasonCodes = data;
      this._setReleaseCodeOptionsForCandidates();
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _getClients(successCallback) {
    this.candidateService.getAllClientsOrBu(this.authService.getUserDetails(), (data) => {
      this.clients = data;
      this.clients.forEach(client => {
        if (client.companyType == 'Corporation') {
          client.name = "<span style='padding-right:5px'>" + client.name + "</span><i class='fas fa-share-alt'></i>";
        }
      });
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _getCandidatesInfo() {
    this.isLoading = true;
    this.jobMatchesDataArray.forEach(val => {
      let jobMatchIdsArray = [];
      jobMatchIdsArray.push(val.jobMatchId);
      this.getCandidateJobMatchCardInfo(val.jobMatchId, val.candidateId, (jobMatchData) => {
        val.loadingFlag = false;
        val.jobMatchData = jobMatchData;
        this.isSharedRequisition = jobMatchData.isSharedRequisition;
        this.getPendingItems(jobMatchIdsArray, (pendingItemsData) => {
          val.pendingItemsData = pendingItemsData;
          val.loadingPendingItemsFlag = false;
          let statusCanBeSetFlag = true;
          if (val.isCandidateStatusAlreadyChanged) {
            statusCanBeSetFlag = false;
            val.pendingItemsExistFlag = true;
            val.showAlert = true;
            val.message = " (current status: '" + val.jobMatchData.jobMatchCurrentState + "').";
          } else if (_.isUndefined(val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId]) && _.isUndefined(val.pendingItemsData.pendingMeetingDetail[val.jobMatchId]) && _.isUndefined(val.pendingItemsData.filledOrJoinedCandidateDetail[val.jobMatchId])) {
            statusCanBeSetFlag = true;
            val.pendingItemsExistFlag = false;
            val.showAlert = false;
            val.message = " (current status: '" + val.jobMatchData.jobMatchCurrentState + "').";
          } else if (!_.isUndefined(val.pendingItemsData.filledOrJoinedCandidateDetail[val.jobMatchId])) {
            val.pendingItemsExistFlag = true;
            val.showAlert = true;
            val.message = " is in '" + val.jobMatchData.jobMatchCurrentState + "' status.";
            statusCanBeSetFlag = false;
          } else if (!_.isUndefined(val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId])) {
            if (val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId][0].inSentAssessmentState) {
              val.pendingItemsExistFlag = true;
              val.showAlert = true;
              if (val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Technical') {
                val.message = " (current status: '" + val.jobMatchData.jobMatchCurrentState + "'). <b>The Technical Assessment sent will be cancelled and the concerned parties will be notified. This action cannot be reversed.</b>";
              } else if (val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Value') {
                val.message = " (current status: '" + val.jobMatchData.jobMatchCurrentState + "'). <b>The Value Assessment sent will be cancelled and the concerned parties will be notified. This action cannot be reversed.</b>.";
              }
              statusCanBeSetFlag = true;
            } else if (val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId][0].inprogressAny) {
              val.pendingItemsExistFlag = true;
              val.showAlert = true;
              if (val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Technical') {
                val.message = " is in '" + val.jobMatchData.jobMatchCurrentState + "' status.";
              } else if (val.pendingItemsData.pendingAssessmentDetail[val.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Value') {
                val.message = " is in '" + val.jobMatchData.jobMatchCurrentState + "' status.";
              }
              statusCanBeSetFlag = false;
            } else {
              statusCanBeSetFlag = true;
              val.pendingItemsExistFlag = false;
              val.showAlert = false;
              val.message = " (current status: '" + val.jobMatchData.jobMatchCurrentState + "').";
            }
          } else if (!_.isUndefined(val.pendingItemsData.pendingMeetingDetail[val.jobMatchId])) {
            if (val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].inprogressAny) {
              val.pendingItemsExistFlag = true;
              val.showAlert = true;
              if (val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].pendingMeetings[0].type == 'INTERVIEW') {
                val.message = " is in '" + val.jobMatchData.jobMatchCurrentState + "' status";
                val.meetingType = 'Interview';
                val.meetingsPopOverTitle = "'Interviews' that are in progress";
                val.meetingUserLabel = 'Interviewer';
              } else if (val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].pendingMeetings[0].type == 'PHONE_SCREEN') {
                val.message = " is in '" + val.jobMatchData.jobMatchCurrentState + "' status";
                val.meetingType = 'Phone Screen';
                val.meetingsPopOverTitle = "'Phone Screens' that are in progress";
                val.meetingUserLabel = 'Phone Screener';
              }
              val.meetingInfoArray = this._getMeetingDetails(val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].pendingMeetings);
              statusCanBeSetFlag = false;
            } else if (val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].completedAny || val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].completedAll || !val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].inprogressAny) {
              val.pendingItemsExistFlag = true;
              val.showAlert = true;
              if (val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].pendingMeetings[0].type == 'INTERVIEW') {
                val.message = " (current status: '" + val.jobMatchData.jobMatchCurrentState + "'). <b>The Scheduled Interview(s) will be cancelled and the concerned parties will be notified. This action cannot be reversed.</b>";
                val.meetingType = 'Interview';
                val.meetingsPopOverTitle = "'Interviews' that will be 'Canceled'";
                val.meetingUserLabel = 'Interviewer';
              } else if (val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].pendingMeetings[0].type == 'PHONE_SCREEN') {
                val.message = " (current status: '" + val.jobMatchData.jobMatchCurrentState + "'). <b>The Scheduled Phone Screen(s) will be cancelled and the concerned parties will be notified. This action cannot be reversed.</b>";
                val.meetingType = 'Phone Screen';
                val.meetingsPopOverTitle = "'Phone Screens' that will be 'Canceled'";
                val.meetingUserLabel = 'Phone Screener';
              }
              val.meetingInfoArray = this._getMeetingDetails(val.pendingItemsData.pendingMeetingDetail[val.jobMatchId][0].pendingMeetings);
              statusCanBeSetFlag = true;
            }
          }
          if (statusCanBeSetFlag || this.statusType == "Delete Job Match") {
            val.selected = true;
            this.jobMatchesWhoseStatusCanBeSetArray.push(val);
          } else {
            this.jobMatchesWhoseStatusCannotBeSetArray.push(val);
          }
          if ((this.jobMatchesWhoseStatusCanBeSetArray.length + this.jobMatchesWhoseStatusCannotBeSetArray.length) == this.jobMatchesDataArray.length) {
            this.loadingJobMatchesAndPendingItemsDataFlag = false;
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        });
      });
    });
  }

  _getOtherJobMatchesOfCandidate(successCallback) {
    let filter = {
      candidateId: this.jobMatchesDataArray[0].candidateId,
      companyId: this.companyId
    };

    this.jobMatchService.getJobMatchDetails(filter, (data) => {
      this.jobMatches = data;
      if (successCallback) {
        successCallback();
      }
    }, error => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setReleaseCodeOptionsForCandidates() {
    let stepName = "";
    this.jobMatchesDataArray.forEach(candidate => {
      candidate.reasonCodesOptions = this.releaseReasonCodes[candidate.workflowStepName];
      stepName = candidate.workflowStepName;
    });
    // this.jobMatchesDataArray.unshift({ id: null, action: stepName, reason: null});
  }

  _getMeetingDetails(meetingsArray) {
    let modifiedMeetingsArray = [];
    meetingsArray.forEach(meeting => {
      meeting.startDateTime = new Date(meeting.startTime);
      meeting.endDateTime = new Date(meeting.endTime);
      switch (meeting.status) {
        case 'SCHEDULED':
          meeting.statusClass = 'fa fa-calendar set-job-match-status-meeting-icon-scheduled';
          meeting.statusLabel = 'Scheduled';
          break;
        case 'IN_PROGRESS':
          meeting.statusClass = 'fa fa-hourglass-half set-job-match-status-meeting-icon-in-progress';
          meeting.statusLabel = 'In Progress';
          break;
        case 'COMPLETED':
          meeting.statusClass = 'fa fa-check set-job-match-status-meeting-icon-completed';
          meeting.statusLabel = 'Completed';
          break;
        case 'OVERDUE':
          meeting.statusClass = 'fas fa-clock set-job-match-status-meeting-icon-overdue';
          meeting.statusLabel = 'Overdue';
          break;
        case 'CANCELLED':
          meeting.statusClass = 'fa fa-ban set-job-match-status-meeting-icon-cancelled';
          meeting.statusLabel = 'Canceled';
          break;
        default:
          // set defaults
          meeting.statusClass = 'fa fa-question set-job-match-status-meeting-icon-in-progress';
          meeting.statusLabel = 'Status Unknown';
      }
      meeting.userName = meeting.participants[0].name;
      modifiedMeetingsArray.push(meeting);
    });
    return modifiedMeetingsArray;
  }

  setJobMatchStatus() {
    if (!this.setStatusForm.invalid) {
      this.savingFlag = true;
      let statusDataArray = [];
      let updatePendingItemsJobMatchIdsArray = [];
      this.jobMatchesWhoseStatusCanBeSetArray.forEach(jobMatch => {
        if (jobMatch.pendingItemsExistFlag && jobMatch.selected) {
          updatePendingItemsJobMatchIdsArray.push(jobMatch.jobMatchId);
        }
      });

      this.jobMatchesWhoseStatusCanBeSetArray.forEach(val => {
        let tempObject: any = {};
        if (val.selected) {
          tempObject.companyId = this.companyId;
          tempObject.jobMatchId = val.jobMatchId;
          tempObject.notes = this.notes;
          tempObject.externalNote = this.externalNote;
          tempObject.reasonCodeDTO = val.reasonCode;
          tempObject.doNotHire = this.doNotHire;
          tempObject.doNotHireForCompanyIds = [];
          statusDataArray.push(tempObject);
        }
      });
      if (this.statusType == 'Release' && !this.multipleFlag && this.doNotHire) {
        statusDataArray[0].reasonCodeDTO = null;
        if (this._areDetailsValid()) {
          if (this.doNotHireAtClient) {
            statusDataArray[0].doNotHireForCompanyIds = this.selectedClients.map(client => client.id);
          } else {
            statusDataArray[0].doNotHireForCompanyIds.push(this.companyId);
          }
        } else {
          this.savingFlag = false;
          return;
        }
      }

      if (updatePendingItemsJobMatchIdsArray.length > 0) {
        this.jobMatchService.updatePendingItems(updatePendingItemsJobMatchIdsArray, (updatePendingItemsResponse) => {
          this._setJobMatchStatusAndCallSaveBack(statusDataArray);
        }, (error) => {
          this.savingFlag = false;
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      } else if (statusDataArray.length > 0) {
        this._setJobMatchStatusAndCallSaveBack(statusDataArray);
      } else if (statusDataArray.length == 0 && this.jobMatchesWhoseStatusCanBeSetArray.length > 0 && (this.statusType == "Not Interested" || this.statusType == "Release")) {
        this.alertsAndNotificationsService.showAlertWithCallBack('No Candidates!', 'No Candidates Selected!', 'warning', () => {
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
        this.savingFlag = false;
      }
    }
  }

  _setJobMatchStatusAndCallSaveBack(statusDataArray) {
    if (this.statusType == "Release" || this.statusType == "Not Interested") {
      this.jobMatchService.setJobMatchStatus(this.statusType, statusDataArray, (setJobMatchStatusResponse) => {
        this.savingFlag = false;
        if (this.saveCallback) {
          this.saveCallback.emit();
        }
      }, (error) => {
        this.savingFlag = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else if (this.statusType == "Delete Job Match") {
      let deleteJobMatchesObject: any = {};
      let jobMatchIdsArray = [];
      statusDataArray.forEach((status, key) => {
        jobMatchIdsArray.push(status.jobMatchId);
      });
      deleteJobMatchesObject.jobMatchIds = angular.copy(jobMatchIdsArray);
      deleteJobMatchesObject.note = statusDataArray[0].notes;
      this.jobMatchService.deleteJobMatches(deleteJobMatchesObject, (data) => {
        this.savingFlag = false;``
        this.alertsAndNotificationsService.showBannerMessage("Job match deleted successfully", 'success');
        if (this.saveCallback) {
          this.saveCallback.emit();
        }
      }, (error) => {
        this.savingFlag = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  getCandidateJobMatchCardInfo(jobMatchId, candidateId, successCallback) {
    this.jobMatchService.getCandidateJobMatchCard(jobMatchId, this.companyId, (data) => {
      let candidateJobMatch = {};
      angular.merge(candidateJobMatch, data);
      candidateJobMatch = this._massageCandidateJobMatchData(candidateJobMatch);
      if (successCallback) {
        successCallback(candidateJobMatch);
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    }, undefined);
  }

  getPendingItems(jobMatchIdsArray, successCallback) {
    this.jobMatchService.getPendingItems(jobMatchIdsArray, (data) => {
      if (successCallback) {
        successCallback(data);
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _massageCandidateJobMatchData(candidateJobMatch) {
    if (_.isNull(candidateJobMatch.firstName)) {
      candidateJobMatch.firstName = "-";
    }
    if (_.isNull(candidateJobMatch.lastName)) {
      candidateJobMatch.lastName = "-";
    }
    candidateJobMatch.name = candidateJobMatch.firstName + ' ' + candidateJobMatch.lastName;
    return candidateJobMatch;
  }

  onInternalNoteChanged() {
    this.externalNote = this.notes;
  }

  onExternalNoteChange(event) {
    this.externalNote = event.externalNote;
  }

  onCopyNoteChange(event) {
    this.copyNote = event.copyNote;
  }

  onDoNotHireAtChange() {
    if (!this.doNotHireAtClient) {
      this.selectedClients = [];
      this.clients.forEach(client => {
        client.ticked = false;
      });
    }
  }

  _areDetailsValid() {
    return !this.doNotHireAtClient || (this.doNotHireAtClient && this.selectedClients.length > 0);
  }

  selectAllClients() {
    this.selectedClients = [...this.clients];
  }

  deSelectAllClients() {
    this.selectedClients = [];
  }

  receiveFormalizedComment(event) {
    this.notes = event;
  }

  onVoiceTranscript(transcript: string) {
    if (this.notes) {
      this.notes += ' ' + transcript;
    } else {
      this.notes = transcript;
    }
  }

}
